import React from "react";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as SeparatorDots } from "../assets/icons/separatorDots.svg";
import { dataCareers as jobs } from "../Components/Data/dataCareers";
import Lightbox from "../Components/Lightbox";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../Components/PrimaryButton";
import InputField from "../Components/InputField";
import TextArea from "../Components/TextArea";
import SubmitButton from "../Components/SubmitButton";

function Careers() {
    const navigate = useNavigate();

    const [isModalOpen, setIsModalOpen] = useState(false);
    /**
     * Monitor when the esc key is pressed and close the menu
     */
    useEffect(() => {
        const handleKeyDown = (e) => {
        if (e.key === 'Escape' && isModalOpen) {
            setIsModalOpen(false);
        }
        };
    
        window.addEventListener('keydown', handleKeyDown);
    
        return () => {
        window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isModalOpen]);

      /**
     * Navigates the user to home.
     */
    const onSendClick = () => {
        navigate("/");
    };

    /**
     * Clears the input fields in the contact us form.
     */
    const onClearClick = () => {
        setMessage("");
        setName("");
        setEmail("");
        setSubject("");
    };
    
    const [selectedJob, setSelectedJob] = useState(null);

    const onSeeMoreClick = (job) => {
        setSelectedJob(job);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedJob(null);
    };

    const [message, setMessage] = useState();
    const [email, setEmail] = useState();
    const [name, setName] = useState();
    const [subject, setSubject] = useState();

    return (
        <>
        <h1 className="seo-only">Crew call for Final Version 2</h1>
        <h2 className="seo-only">Explore careers at Final Version 2.</h2>
        <div className='careers-page'>
            <div className='careers-page-center'>
            <div className='careers-details-top'>
                <div className='careers-list-title'> Work That Matters.<br/>People That Care.</div>

                <p className="text">
                We’re a team that cares deeply about the work we make and the people we make it with. You’ll have room to contribute meaningfully, take ownership, and work closely with people who value collaboration and doing things well.
                </p>

                <p className="text">
                As artists ourselves, we believe good work doesn’t need rigid routines or a traditional corporate ladder; flexibility, trust, and clear expectations can coexist. There’s room to step outside, reset, enjoy the sun, and have a life beyond the screen.
                </p>

                <p className="text"> We move quickly, learn constantly, and try to create an environment where good ideas
                can come from anywhere.</p>

                <SeparatorDots className="separator_dots"/>

                <div className="sub-title">Open Roles</div>

                <div className="job-table">
                    {jobs.map((job, index) => (
                        <div key={index} className="job-row">
                        <div className="job-cell">{job.jobTitle}</div>
                        <div className="job-cell">{job.dept}</div>
                        <div className="job-cell">{job.workMode}</div>
                        <button className="apply-btn" onClick={() => onSeeMoreClick(job)}>
                            Apply -{'>'}
                        </button>
                        <div className={`row-separator ${index % 3 === 0 ? 'row-separator-pink' : index % 3 === 1 ? 'row-separator-blue' : 'row-separator-yellow'}`} /></div>
                    ))}

                    <Lightbox isOpen={isModalOpen} onClose={closeModal}>
                         {selectedJob ? (
                            <div className="job-application">
                                <div className="application-title">{selectedJob.jobTitle}</div>
                                {/* <p><span className="application-subtitle">Department:</span> {selectedJob.dept}</p> */}
                                {/*<p><strong>Work Mode:</strong> {selectedJob.workMode}</p>*/}
                                <p>{selectedJob.dept} - {selectedJob.workMode}</p>

                                <p>{selectedJob.aboutRole}</p>

                                <div className="application-subtitle">What You'll Do</div>
                                <ul>
                                    {selectedJob.whatYoullDo.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                    ))}
                                </ul>

                                <div className="application-subtitle">What You'll Need</div>
                                <ul>
                                    {selectedJob.whatYoullNeed.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                    ))}
                                </ul>

                                <p><strong>Salary:</strong> ${selectedJob.salary}</p>

                                <br/>
                                <hr />
                                <p>
                                    To apply, email{" "}
                                    <strong>
                                        <a href="mailto:joincrew@finalversion2.com">
                                            joincrew@finalversion2.com
                                        </a>
                                    </strong>{" "}
                                    with:
                                </p>

                                <ul>
                                    <li>Role title in the subject line</li>
                                    <li>Resume attached</li>
                                    <li>Reel/portfolio included</li>
                                </ul>

                                <p>
                                    Applications missing any of the above, or sent to a different email address,
                                    will not be reviewed.
                                </p>
                            </div>
                        ) : null}
                    </Lightbox>
                </div>

                <SeparatorDots className="separator_dots"/>

                {/* Benefits XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX */}
                {/*
                <div className="services-section">
                    <ul className='services'>
                        <li>
                            <h3 className='service-title'> Visual Effects </h3>
                            <p className='service-description'>
                            Let's fix those green screens, or how about little compositing magic? Perhaps, you're looking to show off your product in 3D space?
                            </p>
                        </li>
                        <li>
                            <h3 className='service-title'> Motion Graphics </h3>
                            <p className='service-description'>
                            Title sequences set the stage for the story. Those text bubbles help translate the story. UI/HUDs could be the story itself!
                            </p>
                        </li>
                        <li>
                            <h3 className='service-title'> Production </h3>
                            <p className='service-description'>
                            We can help you plan Virtual Production and take care of on-set VFX. Our kit bag is a kit room; get gear for your production needs!
                            </p>
                        </li>
                    </ul>
                </div>

                <SeparatorDots className="separator_dots"/>
                */}
                {/* Values XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX*/}
                {/*
                <div className="services-section">
                    <ul className='services'>
                        <li>
                            <h3 className='service-title'> Visual Effects </h3>
                            <p className='service-description'>
                            Let's fix those green screens, or how about little compositing magic? Perhaps, you're looking to show off your product in 3D space?
                            </p>
                        </li>
                        <li>
                            <h3 className='service-title'> Motion Graphics </h3>
                            <p className='service-description'>
                            Title sequences set the stage for the story. Those text bubbles help translate the story. UI/HUDs could be the story itself!
                            </p>
                        </li>
                        <li>
                            <h3 className='service-title'> Production </h3>
                            <p className='service-description'>
                            We can help you plan Virtual Production and take care of on-set VFX. Our kit bag is a kit room; get gear for your production needs!
                            </p>
                        </li>
                    </ul>
                </div>
                */}
            </div>
            </div>
        </div>
        </>
    );
}
export default Careers;
